/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CsobCompanyInfoDto } from '../models';
// @ts-ignore
import type { CsobDataSetDataDto } from '../models';
// @ts-ignore
import type { CsobFormMetaDataDto } from '../models';
// @ts-ignore
import type { CsobSendDataSetResponseDto } from '../models';
// @ts-ignore
import type { CsobTokenExpirationDto } from '../models';
// @ts-ignore
import type { UpdateCsobCompanyDatasetDto } from '../models';
// @ts-ignore
import type { UpdateCsobFormMetaDataDto } from '../models';
// @ts-ignore
import type { UpdateCsobUserDatasetChoiceDto } from '../models';
/**
 * CsobHubApi - axios parameter creator
 * @export
 */
export const CsobHubApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerAcceptCredacCodeChange: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/csob-hub/accept-credac-code-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CsobFormMetaDataDto} csobFormMetaDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerCreateFormMetaData: async (csobFormMetaDataDto: CsobFormMetaDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csobFormMetaDataDto' is not null or undefined
            assertParamExists('csobHubControllerCreateFormMetaData', 'csobFormMetaDataDto', csobFormMetaDataDto)
            const localVarPath = `/api/csob-hub/create-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(csobFormMetaDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetCsobDatasetComparison: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/csob-hub/dataset-comparison`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetCsobTokenExpiration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/csob-hub/user-token-expiration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetCurrentCsobCompanyInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/csob-hub/company-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetForms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/csob-hub/forms-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerRemoveForm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('csobHubControllerRemoveForm', 'id', id)
            const localVarPath = `/api/csob-hub/delete-form/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerSendDataSetToCsob: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/csob-hub/send-dataset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCsobCompanyDatasetDto} updateCsobCompanyDatasetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerUpdateCompanyDataset: async (updateCsobCompanyDatasetDto: UpdateCsobCompanyDatasetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCsobCompanyDatasetDto' is not null or undefined
            assertParamExists('csobHubControllerUpdateCompanyDataset', 'updateCsobCompanyDatasetDto', updateCsobCompanyDatasetDto)
            const localVarPath = `/api/csob-hub/company-dataset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCsobCompanyDatasetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCsobFormMetaDataDto} updateCsobFormMetaDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerUpdateFormMetaData: async (id: string, updateCsobFormMetaDataDto: UpdateCsobFormMetaDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('csobHubControllerUpdateFormMetaData', 'id', id)
            // verify required parameter 'updateCsobFormMetaDataDto' is not null or undefined
            assertParamExists('csobHubControllerUpdateFormMetaData', 'updateCsobFormMetaDataDto', updateCsobFormMetaDataDto)
            const localVarPath = `/api/csob-hub/update-form/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCsobFormMetaDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCsobUserDatasetChoiceDto} updateCsobUserDatasetChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerUpdateUserModalViewedVersion: async (updateCsobUserDatasetChoiceDto: UpdateCsobUserDatasetChoiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCsobUserDatasetChoiceDto' is not null or undefined
            assertParamExists('csobHubControllerUpdateUserModalViewedVersion', 'updateCsobUserDatasetChoiceDto', updateCsobUserDatasetChoiceDto)
            const localVarPath = `/api/csob-hub/user-modal-viewed-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCsobUserDatasetChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CsobHubApi - functional programming interface
 * @export
 */
export const CsobHubApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CsobHubApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerAcceptCredacCodeChange(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerAcceptCredacCodeChange(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerAcceptCredacCodeChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CsobFormMetaDataDto} csobFormMetaDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerCreateFormMetaData(csobFormMetaDataDto: CsobFormMetaDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerCreateFormMetaData(csobFormMetaDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerCreateFormMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerGetCsobDatasetComparison(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsobDataSetDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerGetCsobDatasetComparison(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerGetCsobDatasetComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerGetCsobTokenExpiration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsobTokenExpirationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerGetCsobTokenExpiration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerGetCsobTokenExpiration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerGetCurrentCsobCompanyInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsobCompanyInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerGetCurrentCsobCompanyInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerGetCurrentCsobCompanyInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerGetForms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CsobFormMetaDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerGetForms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerGetForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerRemoveForm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerRemoveForm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerRemoveForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerSendDataSetToCsob(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsobSendDataSetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerSendDataSetToCsob(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerSendDataSetToCsob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCsobCompanyDatasetDto} updateCsobCompanyDatasetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerUpdateCompanyDataset(updateCsobCompanyDatasetDto: UpdateCsobCompanyDatasetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerUpdateCompanyDataset(updateCsobCompanyDatasetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerUpdateCompanyDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCsobFormMetaDataDto} updateCsobFormMetaDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerUpdateFormMetaData(id: string, updateCsobFormMetaDataDto: UpdateCsobFormMetaDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerUpdateFormMetaData(id, updateCsobFormMetaDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerUpdateFormMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCsobUserDatasetChoiceDto} updateCsobUserDatasetChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csobHubControllerUpdateUserModalViewedVersion(updateCsobUserDatasetChoiceDto: UpdateCsobUserDatasetChoiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csobHubControllerUpdateUserModalViewedVersion(updateCsobUserDatasetChoiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsobHubApi.csobHubControllerUpdateUserModalViewedVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CsobHubApi - factory interface
 * @export
 */
export const CsobHubApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CsobHubApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerAcceptCredacCodeChange(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.csobHubControllerAcceptCredacCodeChange(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CsobFormMetaDataDto} csobFormMetaDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerCreateFormMetaData(csobFormMetaDataDto: CsobFormMetaDataDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.csobHubControllerCreateFormMetaData(csobFormMetaDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetCsobDatasetComparison(options?: RawAxiosRequestConfig): AxiosPromise<CsobDataSetDataDto> {
            return localVarFp.csobHubControllerGetCsobDatasetComparison(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetCsobTokenExpiration(options?: RawAxiosRequestConfig): AxiosPromise<CsobTokenExpirationDto> {
            return localVarFp.csobHubControllerGetCsobTokenExpiration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetCurrentCsobCompanyInfo(options?: RawAxiosRequestConfig): AxiosPromise<CsobCompanyInfoDto> {
            return localVarFp.csobHubControllerGetCurrentCsobCompanyInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerGetForms(options?: RawAxiosRequestConfig): AxiosPromise<Array<CsobFormMetaDataDto>> {
            return localVarFp.csobHubControllerGetForms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerRemoveForm(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.csobHubControllerRemoveForm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerSendDataSetToCsob(options?: RawAxiosRequestConfig): AxiosPromise<CsobSendDataSetResponseDto> {
            return localVarFp.csobHubControllerSendDataSetToCsob(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCsobCompanyDatasetDto} updateCsobCompanyDatasetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerUpdateCompanyDataset(updateCsobCompanyDatasetDto: UpdateCsobCompanyDatasetDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.csobHubControllerUpdateCompanyDataset(updateCsobCompanyDatasetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCsobFormMetaDataDto} updateCsobFormMetaDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerUpdateFormMetaData(id: string, updateCsobFormMetaDataDto: UpdateCsobFormMetaDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.csobHubControllerUpdateFormMetaData(id, updateCsobFormMetaDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCsobUserDatasetChoiceDto} updateCsobUserDatasetChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csobHubControllerUpdateUserModalViewedVersion(updateCsobUserDatasetChoiceDto: UpdateCsobUserDatasetChoiceDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.csobHubControllerUpdateUserModalViewedVersion(updateCsobUserDatasetChoiceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CsobHubApi - object-oriented interface
 * @export
 * @class CsobHubApi
 * @extends {BaseAPI}
 */
export class CsobHubApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerAcceptCredacCodeChange(options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerAcceptCredacCodeChange(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CsobFormMetaDataDto} csobFormMetaDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerCreateFormMetaData(csobFormMetaDataDto: CsobFormMetaDataDto, options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerCreateFormMetaData(csobFormMetaDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerGetCsobDatasetComparison(options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerGetCsobDatasetComparison(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerGetCsobTokenExpiration(options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerGetCsobTokenExpiration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerGetCurrentCsobCompanyInfo(options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerGetCurrentCsobCompanyInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerGetForms(options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerGetForms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerRemoveForm(id: string, options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerRemoveForm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerSendDataSetToCsob(options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerSendDataSetToCsob(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCsobCompanyDatasetDto} updateCsobCompanyDatasetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerUpdateCompanyDataset(updateCsobCompanyDatasetDto: UpdateCsobCompanyDatasetDto, options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerUpdateCompanyDataset(updateCsobCompanyDatasetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateCsobFormMetaDataDto} updateCsobFormMetaDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerUpdateFormMetaData(id: string, updateCsobFormMetaDataDto: UpdateCsobFormMetaDataDto, options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerUpdateFormMetaData(id, updateCsobFormMetaDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCsobUserDatasetChoiceDto} updateCsobUserDatasetChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsobHubApi
     */
    public csobHubControllerUpdateUserModalViewedVersion(updateCsobUserDatasetChoiceDto: UpdateCsobUserDatasetChoiceDto, options?: RawAxiosRequestConfig) {
        return CsobHubApiFp(this.configuration).csobHubControllerUpdateUserModalViewedVersion(updateCsobUserDatasetChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }
}

